import makeValidationSchema from './SummaryReferenceMakeValidationSchema'
import { components, useTranslation } from 'cng-web-lib'
import React from 'react'
import Namespace from '../../../constants/locale/Namespace'
import NBCICanadaInvoiceKeys from '../../../constants/locale/key/NBCICanadaInvoice'
import Grid from '@material-ui/core/Grid'

const {
  form: {
    field: { CngTextField, CngCodeMasterAutocompleteField }
  },
  CngGridItem
} = components

const DEFAULT_INITIAL_VALUES = Object.freeze({
  additionDeductionInd: '',
  additionDeductionCode: '',
  amountRatePercent: '',
  additionDeductionType: '',
  explanation: ''
})

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES },
  makeValidationSchema: makeValidationSchema
}

function Fields({ disabled, shouldHideMap }) {
  const { translate } = useTranslation(Namespace.N_B_C_I_CANADA_INVOICE)
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    const additionDeductionInd = translate(
      Namespace.N_B_C_I_CANADA_INVOICE,
      NBCICanadaInvoiceKeys.InvSummaryReference.ADDITION_DEDUCTION_IND
    )
    const additionDeductionCode = translate(
      Namespace.N_B_C_I_CANADA_INVOICE,
      NBCICanadaInvoiceKeys.InvSummaryReference.ADDITION_DEDUCTION_CODE
    )
    const additionDeductionType = translate(
      Namespace.N_B_C_I_CANADA_INVOICE,
      NBCICanadaInvoiceKeys.InvSummaryReference.ADDITION_DEDUCTION_TYPE
    )
    const amountRatePercent = translate(
      Namespace.N_B_C_I_CANADA_INVOICE,
      NBCICanadaInvoiceKeys.InvSummaryReference.AMOUNT_RATE_PERCENT
    )
    const explanation = translate(
      Namespace.N_B_C_I_CANADA_INVOICE,
      NBCICanadaInvoiceKeys.InvSummaryReference.EXPLANATION
    )

    return {
      additionDeductionCode,
      additionDeductionInd,
      additionDeductionType,
      amountRatePercent,
      explanation
    }
  }

  return (
    <Grid container spacing={1}>
      <CngGridItem xs={12} md={3} shouldHide={shouldHideMap?.additionDeductionInd}>
        <CngCodeMasterAutocompleteField
          name='additionDeductionInd'
          label={translatedTextsObject.additionDeductionInd}
          disabled={disabled}
          size='small'
          codeType='CA_INV_ADD_DED_IND'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={4} md={3} shouldHide={shouldHideMap?.additionDeductionCode}>
        <CngCodeMasterAutocompleteField
          name='additionDeductionCode'
          label={translatedTextsObject.additionDeductionCode}
          disabled={disabled}
          size='small'
          codeType='CA_INV_ADD_DED_CODE'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={4} md={3} shouldHide={shouldHideMap?.additionDeductionType}>
        <CngCodeMasterAutocompleteField
          name='additionDeductionType'
          label={translatedTextsObject.additionDeductionType}
          disabled={disabled}
          size='small'
          codeType='CA_INV_ADD_DED_TYPE'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={4} md={3} shouldHide={shouldHideMap?.amountRatePercent}>
        <CngTextField
          name='amountRatePercent'
          label={translatedTextsObject.amountRatePercent}
          disabled={disabled}
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} shouldHide={shouldHideMap?.explanation}>
        <CngTextField
          name='explanation'
          label={translatedTextsObject.explanation}
          disabled={disabled}
          size='small'
        />
      </CngGridItem>
    </Grid>
  )
}

const SummaryReferenceFormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields: Fields
})

export default SummaryReferenceFormProperties
